import axios from 'axios';

const config = {
  baseURL: process.env.REACT_APP_BASEURL_BACK,
  timeout: 240000,
};

const api2 = axios.create(config);

api2.interceptors.request.use(async (config) => {
  const session = JSON.parse(localStorage.getItem('@EC-session'));

  if (!config.headers.Authorization || config.headers.Authorization && session.token) {
    config.headers.Authorization = `Bearer ${session.token}`;
    return config;
  }

  return Promise.reject(
    {
      response: {
        status: 401,
        data: {
          error: 'unauthorized',
          error_description: 'Full authentication is required to access this resource'
        }
      }
    }
  );
}, err => {
  console.log(err)
  return Promise.reject(err);
});

api2.interceptors.response.use(
  (response) => response, // Retorna la respuesta directamente si no hay error.
  (error) => {
    // Aquí puedes controlar cómo manejar los errores.
    if (error.response && error.response.status === 400) {
      // En lugar de rechazar el error, retornarlo como una respuesta manejable.
      return error.response;
    }

    //Para otros errores que no sean 400, manejar normalmente
    return Promise.reject(error);
  }
);

export default api2;
